import { useDraggable } from '@dnd-kit/core'
import { CSS } from '@dnd-kit/utilities'

import { EMPTY_OBJECT } from '../../../constants/common'
import { isEventFromOwnDom } from '../../../utils/events'
import {
  DRAG_DROP_DATA_ATTR,
  DRAG_DROP_INTERACTION_STYLE,
} from '../DragDrop.constants'
import { getDragDropDraggableAttributes } from '../DragDrop.utils'

function DragDropDraggableItem({
  children,
  draggableProps = EMPTY_OBJECT,
  draggingStyle = EMPTY_OBJECT,
  hasInteractiveChildren = false,
  id,
  keepInPlace = false,
  style = EMPTY_OBJECT,
  ...restProps
}) {
  const {
    attributes,
    isDragging,
    listeners,
    setActivatorNodeRef,
    setNodeRef,
    transform,
  } = useDraggable({ ...draggableProps, id })

  function handleRef(node) {
    setNodeRef(node)

    if (hasInteractiveChildren) {
      setActivatorNodeRef(node)
    }
  }

  // The pointer sensor ignores the target: a press in a child's portal drags.
  function handlePointerDown(event) {
    if (isEventFromOwnDom(event)) {
      listeners?.onPointerDown(event)
    }
  }

  const itemStyle = {
    ...DRAG_DROP_INTERACTION_STYLE,
    ...style,
    ...(isDragging ? draggingStyle : null),
    transform:
      keepInPlace && isDragging ? undefined : CSS.Transform.toString(transform),
  }

  return (
    <div
      {...getDragDropDraggableAttributes({
        attributes,
        hasInteractiveChildren,
      })}
      {...listeners}
      {...(hasInteractiveChildren
        ? { onPointerDown: handlePointerDown }
        : null)}
      {...restProps}
      {...{
        [DRAG_DROP_DATA_ATTR.isDragging]: isDragging,
      }}
      ref={handleRef}
      style={itemStyle}
    >
      {children}
    </div>
  )
}

export default DragDropDraggableItem
